import Vue from 'vue';
import App from './App.vue';
import RawlplugWebinarsPlugin from "./RawlplugWebinarsPlugin";
import VueRouter from 'vue-router';
import EventsCalendar, {
  plugin as EventsCalendarPlugin,
  sharedMessages,
  EventsFilterWrapper
} from "@rawlplug/rawlplug-events-calendar/dist/RawlplugEventsCalendar.umd";

import VueI18n from 'vue-i18n'
import Vuex from 'vuex'
import "./main.scss"
import { useMatchMedia } from "./useMatchMedia";
import { setAmp, setInitialHash } from "./components/hash";
import moment from 'moment';

function detectLanguage() {
  if(window.ra) {
    if(window.ra.language) {
      return window.ra.language;
    }

    if(window.ra.settings && window.ra.settings.language) {
      return window.ra.settings.language;
    }
  }
  return document.documentElement.lang;
}

Vue.use(VueRouter)
Vue.use(Vuex)
Vue.use(VueI18n)
const rawlplugWebinarsPluginOptions = {
  forms: {
    contactForm: {
      application: 'webinars',
      categoryID: 17,
    }
  },
  config: {
    ownerCode: "web-webinars",
    api: process.env.VUE_APP_REM_API,
    consentsURL: "https://id.rawlplug.com/api/application/webinars",
    application: "webinars",
    consentsCategory: 17,
    contactFormAPI: process.env.VUE_APP_FORM_API,
    language: detectLanguage(),
    showTrainers: true,
    showPlaceAsOnline: true,
    showGMT: true,
    calendarForm: {
      displayFirstAndLastName: true,
      availableLanguages: 'ALL',
    }
  },
  settings: {
    getLanguage() {
      return detectLanguage()
    }
  }
}

if(window.ra && window.ra.availableLanguages) {
  rawlplugWebinarsPluginOptions.config.calendarForm.availableLanguages = window.ra.availableLanguages;
}

Vue.use(RawlplugWebinarsPlugin, rawlplugWebinarsPluginOptions);
moment.locale(detectLanguage());

const formPL = require('./translations/pl.json').form;
const formEN = require('./translations/en.json').form;
const formFR = require('./translations/fr.json').form;
const formSV = require('./translations/sv.json').form;
const formRU = require('./translations/ru.json').form;
const formLT = require('./translations/lt.json').form;
const formCS = require('./translations/cs.json').form;
const formIT = require('./translations/it.json').form;

sharedMessages.pl.webinars = require('./translations/pl.json').webinars;
sharedMessages.en.webinars = require('./translations/en.json').webinars;
sharedMessages.fr.webinars = require('./translations/fr.json').webinars;
sharedMessages.lt = sharedMessages.lt ?? {};
sharedMessages.lt.webinars = require('./translations/lt.json').webinars,
sharedMessages.ru = sharedMessages.ru ?? {};
sharedMessages.ru.webinars = require('./translations/ru.json').webinars;
sharedMessages.sv = sharedMessages.sv ?? {};
sharedMessages.sv.webinars = require('./translations/sv.json').webinars;
sharedMessages.cs = sharedMessages.cs ?? {};
sharedMessages.cs.webinars = require('./translations/cs.json').webinars;
sharedMessages.it = sharedMessages.it ?? {};
sharedMessages.it.webinars = require('./translations/it.json').webinars;
sharedMessages.pl.form = { ...sharedMessages.pl.form, ...formPL };
sharedMessages.en.form = { ...sharedMessages.en.form, ...formEN };
sharedMessages.fr.form = { ...sharedMessages.fr.form, ...formFR };
sharedMessages.ru.form = { ...sharedMessages.ru.form, ...formRU };
sharedMessages.sv.form = { ...sharedMessages.sv.form, ...formSV };
sharedMessages.lt.form = { ...sharedMessages.lt.form, ...formLT };
sharedMessages.cs.form = { ...sharedMessages.cs.form, ...formCS };
sharedMessages.it.form = { ...sharedMessages.it.form, ...formIT };

const store = new Vuex.Store({});
setInitialHash(window.location.hash)

Vue.use(useMatchMedia, {
  store
})

const i18n = new VueI18n({
  locale: detectLanguage(),
  fallbackLocale: 'pl',
  messages: sharedMessages
})

const router = new VueRouter({});

Vue.use(EventsCalendarPlugin, {
  store,
  config: rawlplugWebinarsPluginOptions.config,
  router,
  plugins: {
    WebinarsCalendarPlugin: {
      formValidations(validations) {
        validations.postCode = {};
        validations.phone = {};

        return validations;
      },
      formFieldsData(fields) {
        return fields.filter(field => !['postCode', 'phone'].includes(field.key))
      }
    }
  }
});
Vue.component('events-calendar', EventsCalendar);
Vue.component('events-filter-wrapper', EventsFilterWrapper);

Vue.config.productionTip = false;

new Vue({
  store,
  i18n,
  router,
  render: (h) => h(App),
}).$mount('#webinars');
